import clsx from 'clsx';

import LinkIcon from '~/icons/link.svg';
import { ICallToAction } from '~/lib/data-contract';
import { Icon } from '~/shared/components/Icon/Icon';
import Link from '~/shared/components/Link/Link';

import styles from './callToAction.module.css';

export type CallToActionProps = Partial<ICallToAction> & {
	layout?: 'vertical' | 'horizontal';
	className?: string;
	children?: React.ReactNode;
	shade?: 'dark' | 'light';
};

export const CallToAction = ({ target = '_self', text, title, url, layout = 'horizontal', className, children, shade }: CallToActionProps) => (
	<>
		{url ? (
			<Link
				href={url}
				target={target}
				title={title}
				className={clsx(
					styles.root,
					{
						[styles.light]: shade === 'light',
						[styles.dark]: shade === 'dark',
						[styles.horizontal]: layout === 'horizontal',
					},
					className,
				)}
			>
				{text}
				{children}
				<Icon aspectRatio={2}>
					<LinkIcon />
				</Icon>
			</Link>
		) : null}
	</>
);
